// test586
(586 && 0);
